
namespace Matrix.Indexation {

    @Serenity.Decorators.registerEditor('Matrix.Indexation.IndexationProfileIndexConstituentRorGrid')
    export class IndexationProfileIndexConstituentRorGrid extends SiteEntityGrid<IndexConstituentRorRow, any> {
        protected getColumnsKey() { return IndexConstituentRorColumns.columnsKey; }
        protected getDialogType() { return IndexConstituentRorDialog; }
        protected getIdProperty() { return IndexConstituentRorRow.idProperty; }
        protected getInsertPermission() { return IndexConstituentRorRow.insertPermission; }
        protected getLocalTextPrefix() { return IndexConstituentRorRow.localTextPrefix; }
        protected getService() { return IndexConstituentRorService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        getInitialTitle() {
            return null;
        }

        private _indexationProfileCode: string;

        get indexationProfileCode(): string {
            return this._indexationProfileCode;
        }

        set indexationProfileCode(value: string) {
            if (this._indexationProfileCode != value) {
                this._indexationProfileCode = value;
                this.setEquality(CompositeConstituentRow.Fields.IndexationProfileCode, value);
                this.refresh();
            }
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._indexationProfileCode;
        }
    }
}